import SeoTaskList from './SeoTaskList.container';

export default SeoTaskList;
